import React from 'react';
import BasicLayout from 'layouts/authentication/components/BasicLayout';

const PublicLayout = ({ children }) => {
  return <BasicLayout>{children}</BasicLayout>;
};

export default PublicLayout;
